import { normalizeCallBehavior } from './normalize-call-behavior';
import { normalizeErrorReporting } from './normalize-error-reporting';
import { pipe } from 'rxjs';

/**
 * Normalize the call behavior and error reporting without trying to apply a schema
 * to the response. This is for those situations like, say, delete where you only
 * care the call didn't error but the response body is of little value. This is the
 * complement to `selectData`.
 *
 * Intended to be used with `fromFetch`.
 *
 * Example use:
 * ```
 * fromFetch('url')
 *  .pipe(ignoreData())
 *  .subscribe({
 *    error: (error: Response) => {
 *       // Report error.
 *       // Okay to use `error.statusText` and `error.status`.
 *       // More details may be in the error body.
 *    },
 *  });
 * ```
 *
 */
export function ignoreData() {
  return pipe(normalizeCallBehavior(), normalizeErrorReporting());
}
